export enum VulnerabilitySeverity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  INFO = 'INFO',
}

export enum VulnerabilityType {
  SAST = 'SAST',
  DAST = 'DAST',
  SCA = 'SCA',
  IAST = 'IAST',
  MANUAL = 'MANUAL',
  PENETRATION_TEST = 'PENETRATION_TEST',
}

export enum VulnerabilityStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  FALSE_POSITIVE = 'FALSE_POSITIVE',
  ACCEPTED_RISK = 'ACCEPTED_RISK',
}

export interface VulnerabilityTimelineEntry {
  id: string;
  action: string;
  oldValue?: string;
  newValue?: string;
  user?: {
    id: number;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  createdAt: Date;
}

export interface VulnerabilityRecord {
  id: string;
  title: string;
  description: string;
  severity: VulnerabilitySeverity;
  type: VulnerabilityType;
  status: VulnerabilityStatus;
  cvss?: number;
  cve?: string;
  cwe?: string;
  component?: string;
  version?: string;
  fixVersion?: string;
  recommendation?: string;
  falsePositive: boolean;
  fpJustification?: string;
  assignedToId?: number;
  createdAt: Date;
  updatedAt: Date;
  resolvedAt?: Date;
  assignedTo?: {
    id: number;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  agents?: Array<{
    id: string;
    name: string;
    hostname?: string;
    ipAddress?: string;
  }>;
  timeline?: VulnerabilityTimelineEntry[];
}

export interface VulnerabilityQuery {
  severity?: VulnerabilitySeverity;
  type?: VulnerabilityType;
  status?: VulnerabilityStatus;
  search?: string;
  assignedToId?: number;
  agentId?: string;
  createdAfter?: string;
  createdBefore?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  hasTicket?: boolean;
}

export interface CreateVulnerabilityInput {
  title: string;
  description: string;
  severity: VulnerabilitySeverity;
  type: VulnerabilityType;
  cvss?: number;
  cve?: string;
  cwe?: string;
  component?: string;
  version?: string;
  fixVersion?: string;
  recommendation?: string;
  assignedToId?: number;
  agentIds?: string[];
}

export interface UpdateVulnerabilityInput
  extends Partial<Omit<CreateVulnerabilityInput, 'agentIds'>> {
  status?: VulnerabilityStatus;
  falsePositive?: boolean;
  fpJustification?: string;
  resolvedAt?: Date;
}

export interface UpdateVulnerabilityStatusInput {
  status: VulnerabilityStatus;
  comment?: string;
}

export interface AssignVulnerabilityInput {
  assignedToId: number;
  comment?: string;
}

export interface MarkFalsePositiveInput {
  justification: string;
}

export interface BulkUpdateVulnerabilitiesInput {
  vulnerabilityIds: string[];
  status?: VulnerabilityStatus;
  assignedToId?: number;
  comment?: string;
}

export interface VulnerabilityStats {
  total: number;
  critical: number;
  high: number;
  medium: number;
  low: number;
  info: number;
  open: number;
  inProgress: number;
  resolved: number;
  falsePositive: number;
  acceptedRisk: number;
}
